import React from 'react';
export const ZoneContext = /*#__PURE__*/ React.createContext(null);
ZoneContext.displayName = 'ZoneContext';
export default ZoneContext;

//# sourceMappingURL=ZoneContext.js.map